import { t } from '@lingui/macro';
import { IconButton, Tooltip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function DocumentHighlights(props) {
    const { getHighlights } = props;
    return (<Tooltip position="left" title={t({
            message: 'Highlight documents references',
            comment: 'Plai Review - Issue Item - Highlights - highlight documents references',
        })}>
      <IconButton size="small" appearance="ghost" onClick={() => getHighlights()}>
        <Falcon icon="highlighter"/>
      </IconButton>
    </Tooltip>);
}
